export default __webpack_public_path__ + "static/media/uploader-tandem-2.cdf5205b.png";